module.exports = __webpack_public_path__ + "res/img_business_bg.eef460c0164ace27b6e482a3ecb7e71a.png";